import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService, ModalConfig } from '../../Services/modal.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-common-modal',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.scss'],
})
export class CommonModalComponent implements OnInit, OnDestroy {
  isOpen = false;
  config: ModalConfig | null = null;
  faXmark = faXmark;
  private subscription: Subscription = new Subscription();
  private readonly destroy$ = new Subject<void>();

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.modalService.modalState$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
        this.isOpen = state.isOpen;
        this.config = state.config;
      })
    );
  }

  close(): void {
    this.modalService.close();
  }

  handleBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.close();
    }
  }

  handleButtonClick(action: () => void, closeOnClick: boolean = true): void {
    action();
    if (closeOnClick) {
      this.close();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  trackByIndex(index: number): number {
    return index;
  }
}
